import { render } from "./import_list.vue?vue&type=template&id=6a2e4fa0"
import script from "./import_list.vue?vue&type=script&lang=js"
export * from "./import_list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__